import { Avatar, Box, Card, Typography } from "@mui/material";
import ValueChangeTopGainersChart from "./ValueChangeTopGainersChart";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { COLORS } from "../../../../ui/Theme";

const ValueChangeTopGainersCard = ({ chartData, unit }) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "10px 12px",
        "&:hover": {
          bgcolor: COLORS.SOFTGRAY,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Avatar
            src="#"
            alt={chartData.symbol}
            sx={{ width: "40px", height: "40px" }}
          />
          <Typography sx={{ fontWeight: 900, fontSize: "14px" }}>
            {chartData.symbol}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color:
                chartData.last_price_change >= 0 ? COLORS.GREEN : COLORS.RED,
              bgcolor:
                chartData.last_price_change >= 0
                  ? COLORS.SOFTGREEN
                  : COLORS.SOFTRED,
              borderRadius: "6px",
              fontSize: "12px",
              p: "2px 4px",
            }}
          >
            {chartData.last_price_change < 0 ? (
              <>
                <KeyboardArrowDown fontSize="small" /> %
                {chartData.last_price_change}
              </>
            ) : (
              <>
                <KeyboardArrowUp fontSize="small" /> %
                {chartData.last_price_change}
              </>
            )}
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 0.3,
            }}
          >
            <span style={{ fontSize: "14px" }}>
              {new Intl.NumberFormat("fa-IR").format(chartData.last_price)}
            </span>
            <span style={{ fontSize: "10px" }}>ریال</span>
          </Typography>
        </Box>
      </Box>
      {chartData.chart && (
        <ValueChangeTopGainersChart
          data={chartData.chart.history}
          latestPriceChange={chartData.last_price_change}
          unit={unit}
          valueChange={chartData.value_change}
        />
      )}

      <Typography
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          fontWeight: 700,
          fontSize: "10px",
          color: COLORS.GRAY,
        }}
      >
        <span>آخرین معامله</span>
        <span>{chartData.last_time}</span>
      </Typography>
    </Card>
  );
};

export default ValueChangeTopGainersCard;
